export default __webpack_public_path__ + "static/media/img6.8a6f8ec0.png";